import { Ng2StateDeclaration } from '@uirouter/angular';
import { FiCustomerSettingsComponent } from '@fi-app/appearance/customer-settings/customer-settings.component';
import { FiCustomerSettingsService } from '@fi-app/appearance/customer-settings/customer-settings.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiAppearanceCustomerSettingsState: Ng2StateDeclaration = {
    name: FiStateNames.Appearance.CustomerSettings,
    url: '/CustomerSettings',
    views: {
        '@': {
            component: FiCustomerSettingsComponent,
        },
    },
    component: FiCustomerSettingsComponent,
    resolve: {
        customerSettings: [FiCustomerSettingsService, FiAppearanceCustomerSettingsStateResolveCustomerSettings],
        pageTitle: [PageTitleService, FiAppearanceCustomerSettingsStateResolvePageTitle],
    },
};

export function FiAppearanceCustomerSettingsStateResolveCustomerSettings(fiCustomerSettingsService) {
    return fiCustomerSettingsService.getCustomerSettings();
}

export function FiAppearanceCustomerSettingsStateResolvePageTitle(ccmPageTitle) {
    return ccmPageTitle.setTitleByTextId('common.appearance');
}
